'use strict'

import axios from 'axios'
import createEndPoint from '../utils/createEndPoint'

const { VUE_APP_TMS_URL } = process.env

export default async ({ id, jwt, object: body }) => {
  if (!id) throw new Error('id not provided')
  if (!jwt) throw new Error('jwt not provided')
  if (!body) throw new Error('body not provided')

  const [type, locale, version] = id.split(':')
  const endPoint = createEndPoint({ type, locale, version })

  return axios({
    method: 'put',
    headers: { Authorization: jwt },
    url: `${VUE_APP_TMS_URL}/${endPoint}`,
    data: body,
    timeout: 8000
  })
}
